var _style, _rect, _path, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStandardLogoHorizontal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 4563.2 1289.9",
    style: {
      enableBackground: "new 0 0 4563.2 1289.9"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#012590;}\r\n\t.st1{fill:url(#SVGID_1_);}\r\n\t.st2{fill:url(#SVGID_00000179618757744210146270000016879298078268990642_);}\r\n\t.st3{fill:#FFFFFF;}\r\n\t.st4{fill:url(#SVGID_00000059267463736338334500000010032114123148115645_);}\r\n\t.st5{fill:none;stroke:#FFFFFF;stroke-width:5.6693;}\r\n")), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: -1.8,
    y: -0.5,
    className: "st0",
    width: 4565.2,
    height: 1290.7
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "SvgjsG1850",
    transform: "matrix(0.9913957356501018,0,0,0.9913957356501018,116.00000618100121,0.000006181001212373423)"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 3308.0469,
    y1: -645.9982,
    x2: 3309.0469,
    y2: -645.9982,
    gradientTransform: "matrix(919.679 0 0 919.679 -3042258.75 594761.375)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#8F5E25"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#FBF4A1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#8F5E25"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M550.2,1118.3c-258.4,0-467.9-209.5-467.9-467.9s209.5-467.9,467.9-467.9s467.8,209.6,467.8,468l0,0 C1017.5,908.6,808.4,1117.8,550.2,1118.3z M550.2,203.2c-247,0-447.3,200.3-447.3,447.3s200.3,447.3,447.3,447.3 s447.3-200.3,447.3-447.3S797.2,203.2,550.2,203.2L550.2,203.2z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "SvgjsG1851",
    transform: "matrix(1.0926243153788293,0,0,1.0926243153788293,143.94405806385183,-9.074954851500848)"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000088128661110783595710000011317548955364542104_",
    gradientUnits: "userSpaceOnUse",
    x1: 2828.3594,
    y1: -440.6513,
    x2: 2829.3594,
    y2: -440.6513,
    gradientTransform: "matrix(475.3347 0 0 594.0364 -1344139 262357.6562)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#8F5E25"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#FBF4A1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#8F5E25"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000088128661110783595710000011317548955364542104_)"
    },
    d: "M448.1,352.5 c-14.5,42.9-51.5,198.1-67.1,264.6c18.8-40.8,48.8-97.1,73-135.8c55.3-85.9,89.1-118.6,124.5-118.6c17.2,0,39.7,14.5,39.7,44.5 c0,30.6-19.3,53.7-51,78.9c-49.4,38.6-63.3,42.9-63.3,51.5c0,5.4,8.1,8.6,34.9,10.2c32.7,1.6,61.2,11.3,78.9,34.4 c14-3.2,24.7-4.8,32.7-6.4c27.4-4.8,31.1,1.1,20.9,2.7c-3.8,0.5-21.5,4.8-47.8,12.9c3.8,6.4,7,14,9.1,22 c14,51-12.3,140.1-147.6,200.2c-105.2,46.7-203.4,34.4-206.6-6.4c-1.6-24.2,21.5-61.2,71.4-100.4c4.8-23.1,11.3-52.1,20.4-88.6 c29.5-124,61.2-251.2,64.9-263C438.4,343.9,451.3,342.8,448.1,352.5L448.1,352.5z M337.5,782.4c-1.1-3.2,0.5-18.2,8.6-59.6 c-40.3,33.8-60.7,65.5-56.9,84.8c5.9,30.1,110,29.5,190-4.8C584.9,758.3,637.5,674,621.4,613.9c-2.1-6.4-4.3-12.9-8.1-18.8 c-41.3,12.9-99.8,33.8-161,62.3c-35.4,16.6-65.5,34.9-90.2,53.1c-10.7,44.5-13.4,67.1-15.6,70.3 C343.9,785.1,338.6,787.2,337.5,782.4z M374.5,663.8l-8.6,30.6c21.5-15,46.2-30.1,75.7-44.5c74.1-36.5,128.3-54.7,164.8-64.4 c-14-16.1-37-27.4-74.1-29.5c-32.2-1.6-38.6-7-40.3-16.6c-1.1-12.3,23.1-24.7,68.7-63.9c33.8-29,45.1-51,45.1-71.4 c0-15.6-10.7-29.5-27.9-29.5c-33.8-0.5-73,41.3-114.9,109C437.9,523.2,395.5,588.1,374.5,663.8L374.5,663.8z"
  }))), /*#__PURE__*/React.createElement("g", null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SvgjsG1852",
    transform: "matrix(0.7839333718959653,0,0,0.7839333718959653,-3.2920490136524228,114.58332274260296)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M1866,670.7c29.2,7.3,48.7,27.4,48.7,61.9c0,39.7-26.9,67.4-71.3,67.4h-97.1V552.9h75.8 c45.6,0,74.4,26.6,74.4,65.7C1896.6,642,1885.9,661.2,1866,670.7L1866,670.7z M1864.1,620.9c0-21.3-15.4-37.9-42.1-37.9h-42v76.9 h47.3C1849.7,659.8,1864.1,642.3,1864.1,620.9L1864.1,620.9z M1837.5,769.4c28.1,0,43.3-18.9,43.3-40.4 c0-22.7-15.9-40.9-45.4-40.9H1780v81.2h57.5V769.4z M2063.5,768.5h84.4v31.4h-119.2v-247h34.8V768.5L2063.5,768.5z M2338.7,803.3 c-51.2,0-90.9-30.2-90.9-86V552.9h34.8v159.5c0,40.7,24.5,59.4,56.1,59.4s56.6-18.9,56.6-59.4V552.9h34.8v164.4 C2430.1,773,2390.2,803.3,2338.7,803.3L2338.7,803.3z M2692.4,584.2h-98.9V661h87.2v31.1h-87.2v76.4h98.9v31.4H2558v-247h134.4 V584.2L2692.4,584.2z M2960,799.9v-247h81.4c76,0,114.6,51,114.6,123.4c0,72.9-38.6,123.7-114.6,123.7H2960V799.9z M2994.7,768.5 h45.3c54,0,79.7-35.8,79.7-92.3c0-56.1-25.7-92.1-79.7-92.1h-45.3V768.5L2994.7,768.5z M3358.6,803.3c-51.2,0-90.9-30.2-90.9-86 V552.9h34.8v159.5c0,40.7,24.5,59.4,56.1,59.4s56.6-18.9,56.6-59.4V552.9h34.8v164.4C3449.9,773,3410.1,803.3,3358.6,803.3 L3358.6,803.3z M3684.3,803.3c-70.1,0-123.5-48.2-123.5-127c0-78.6,53.5-126.7,123.5-126.7c69.7,0,123.4,48,123.4,126.7 C3807.6,755,3754,803.3,3684.3,803.3z M3684.3,770.6c49.4,0,88.6-34.2,88.6-94.3c0-59.6-39.1-93.8-88.6-93.8 c-49.6,0-88.9,34.2-88.9,93.8C3595.3,736.3,3634.7,770.6,3684.3,770.6z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "SvgjsG1853",
    transform: "matrix(0.783921614352426,0,0,0.783921614352426,184.49073532297822,114.58377647452998)"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000070840417639106641130000009512576792808065464_",
    gradientUnits: "userSpaceOnUse",
    x1: 4466.0679,
    y1: -1356.5665,
    x2: 4467.0679,
    y2: -1356.5665,
    gradientTransform: "matrix(942.2191 0 0 155.9026 -4204213.5 212168.6406)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#B88746"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FDF5A6"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000070840417639106641130000009512576792808065464_)"
    },
    d: "M3934.8,584.2h-98.9v76.9h87.2v31.1 h-87.2v76.4h98.9V800h-134.4V552.9h134.4V584.2L3934.8,584.2z M4204.7,552.9h36.7L4150.5,800h-36.3l-90.5-247.1h36.5l72.3,204.4 L4204.7,552.9z M4480.8,584.2h-98.9v76.9h87.2v31.1h-87.2v76.4h98.9V800h-134.4V552.9h134.4V584.2L4480.8,584.2z M4764,552.9h34.6 V800H4761l-129.1-196v196h-34.4V552.9h37.2L4764,748.1V552.9L4764,552.9z M5063.2,552.9v31.3h-62.5V800h-34.4V584.2h-62.7v-31.3 H5063.2L5063.2,552.9z M5245.5,803.3c-51.5,0-89.3-24.6-97.7-66.6l35.5-8.4c5.6,28.8,30.6,45.4,63.4,45.4 c26.4,0,51.7-10.8,51.2-40.5c-0.3-29.4-32.1-37.4-65.9-46.6c-38.3-10.5-76.5-22.5-76.5-68c0-46,37.9-69,82.8-69 c43.5,0,82.6,18.3,91.9,60.8l-33.7,8.6c-6.1-27.4-29-39.7-56.6-39.7c-24.8,0-49.4,10.8-49.4,39c0,25.5,27.6,33,58.9,41.4 c39.3,10.7,84.4,22.9,84.4,72.5C5333.7,782.1,5291.8,803.3,5245.5,803.3L5245.5,803.3z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st5",
    cx: 4434,
    cy: 502.6,
    r: 37.7
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M4431.7,499.2c2.3,0,4-0.5,5.1-1.4c1-0.9,1.6-2.3,1.6-4.3c0-2-0.6-3.4-1.6-4.3c-1-0.9-2.7-1.3-5.1-1.3h-4.8 v11.3H4431.7 M4426.9,506.9v16.6h-11.3v-43.9h17.3c5.8,0,10,1,12.7,2.9c2.7,1.9,4,5,4,9.2c0,2.9-0.7,5.3-2.1,7.1 c-1.4,1.8-3.5,3.2-6.3,4.1c1.6,0.4,2.9,1.2,4.2,2.4c1.2,1.2,2.5,3.1,3.7,5.7l6.2,12.4h-12l-5.4-10.9c-1.1-2.2-2.2-3.7-3.3-4.5 c-1.1-0.8-2.6-1.2-4.4-1.2H4426.9"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStandardLogoHorizontal);
export default __webpack_public_path__ + "static/media/Standard Logo - Horizontal.18e3ea076440b765556a809a88240a6a.svg";
export { ForwardRef as ReactComponent };